import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

export type UiDateRangeQuickOption = {
    id: string;
    label: string;
};

@Injectable()
export class UiDateRangeQuickHeaderService {
    /** Emits when a quick-range button is clicked inside the calendar header. */
    readonly rangeClick$ = new Subject<string>();

    /** Tracks selected range so the header can show selected state. */
    readonly selectedRange$ = new BehaviorSubject<string>('');

    /** Controls the buttons rendered in the header. */
    readonly options$ = new BehaviorSubject<UiDateRangeQuickOption[]>([
        { id: 'hour', label: 'Last Hour' },
        { id: 'day', label: 'Last Day' },
        { id: 'week', label: 'Last Week' },
        { id: 'month', label: 'Last Month' },
    ]);

    clickRange(id: string) {
        this.rangeClick$.next(id);
    }

    setSelectedRange(id: string) {
        this.selectedRange$.next(id);
    }

    setOptions(options: UiDateRangeQuickOption[]) {
        this.options$.next(options);
    }
}

